export const SAVE_SEARCH_HISTORY = 'save_search_history' as const
export const READ_SEARCH_HISTORY = 'read_search_history' as const
export const FLUSH_SEARCH_HISTORY = 'flush_search_history' as const

export default {
  SAVE_SEARCH_HISTORY,
  READ_SEARCH_HISTORY,
  FLUSH_SEARCH_HISTORY
}
